
export const COST_TYPES = {
    none: "none",
    approved: "approved",
    unapproved: "unapproved"
}

export const CJW_CLASS = {
    none: "none",
    apg: "APG",
    asg: "ASG",
    di: "DI"
}


export const COST_TYPE_OPTIONS =  [
    {
        value: COST_TYPES.none,
        label: "Please Select CJW Type"
    },
    {
        value: COST_TYPES.approved,
        label: "Approved"
    },
    {
        value: COST_TYPES.unapproved,
        label: "Draft"
    },
]

export const CJW_CLASS_OPTIONS =  [
    {
        value: CJW_CLASS.none,
        label: "Please Select supplier-flag",
        disabled: false
    },
    {
        value: CJW_CLASS.apg,
        label: "APG",
        disabled: false
    },
    {
        value: CJW_CLASS.asg,
        label: "ASG",
        disabled: true
    },
     {
        value: CJW_CLASS.di,
        label: "DI",
        disabled: true
    },
]

